import '@styles/frontend/main.scss';
import '@scripts/frontend/search-salary-embed/init';
import { CheckSalaryForm } from './check-salary-form';
import { DataVisualizer } from './check-salary-form-data-visualizer';

if (!customElements.get('check-salary-form')) {
  customElements.define('check-salary-form', CheckSalaryForm);
}
if (!customElements.get('check-salary-form-data-visualizer')) {
  customElements.define('check-salary-form-data-visualizer', DataVisualizer);
}
export { CheckSalaryForm, DataVisualizer };
